import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    physicianId: null,
    personInfo: {},
    preferredSpecialty: [],
    preferredInsurance: [],
    previousTraitRatings: [],
    latLong: [],
    locations: [],
    physicianLoading: false,
    physicianError: null,
    groups: [],
};

export const physicianSlice = createSlice({
    name: 'physician',
    initialState,
    reducers: {
        setPhysicianId: (state, action) => {
            state.physicianId = action.payload;
        },
        setPersonInfo: (state, action) => {
            state.personInfo = action.payload;
        },
        setPreferredSpecialty: (state, action) => {
            state.preferredSpecialty = action.payload;
        },
        setPreferredInsurance: (state, action) => {
            state.preferredInsurance = action.payload;
        },
        setPreviousTraitRatings: (state, action) => {
            state.previousTraitRatings = action.payload;
        },
        setLatLong: (state, action) => {
            state.latLong = action.payload;
        },
        setLocations: (state, action) => {
            state.locations = action.payload;
        },
        setLoading: (state, action) => {
            state.physicianLoading = action.payload;
        },
        setError: (state, action) => {
            state.physicianError = action.payload;
        },
        setGroups: (state, action) => {
            state.groups = action.payload;
        },
        resetState: () => {
            return initialState;
        },
    },
});

export const {
    setPhysicianId,
    setPersonInfo,
    setPreferredSpecialty,
    setPreferredInsurance,
    setPreviousTraitRatings,
    setLatLong,
    setLocations,
    setLoading,
    setError,
    resetState,
} = physicianSlice.actions;

export default physicianSlice.reducer;
